export const TOOL_TITLE = 'Update User CRM IDs';
export const FILE_NAME = 'Update-user-crm-id-report';
export const TOOL_PROGRESS_LABEL = 'Bulk User CRM ID updating progress...';

export const MATCHING_LIST = [
    {caption: 'Email', required: true},
    {caption: 'CRM ID'},
];

export const UPLOAD_CRM_TEMPLATE_FILE_NAME = '/static/Bulk Update User CRM ID Template.csv';
export const UPLOAD_FILE_MAX_SIZE_LIMIT_MB = 100;
export const MAX_FILE_SIZE = 100_000_000;
export const UPLOAD_FILE_VALID_EXTENSIONS = ['.csv'];

export const PB_HEADERS: {[key: string]: string} = {
    SFDC: 'SFDC ID',
    MS_DYNAMICS: 'MSDyn ID',
    DEAL_CLOUD: 'DealCloud ID',
    HUBSPOT: 'HubSpot ID',
    EXTERNAL_CRM: 'PB Salesforce ID',
};
